<template>
  <div>
    <h1 class="mb-8 text-3xl font-bold">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('mahasiswa.krs.index')">
        KRS
      </inertia-link>
      <span class="font-medium text-indigo-400">/</span> Create
    </h1>
    <div class="overflow-hidden max-w-3xl bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8 -mr-6 -mb-8">
          <text-input
            v-model="form.school_year"
            :error="form.errors.school_year"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="Tahun Ajaran" />
          <text-input
            v-model="form.school_semester"
            :error="form.errors.school_semester"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="Semester" />
          <text-input
            v-model="form.krs_sks"
            :error="form.errors.krs_sks"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="SKS KRS" />
          <file-input
            v-model="form.krs_file"
            :error="form.errors.krs_file"
            class="pr-6 pb-4 w-1/2"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="Scan hasil KRS" />
        </div>
        <div class="flex justify-end items-center py-4 px-8 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create KRS
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import Swal from 'sweetalert2'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Create KRS' },
    components: {
        LoadingButton,
        TextInput,
        FileInput,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        canCreateKRS: Boolean,
        isInputKrsClosed: Boolean,
    },
    remember: 'form',
    data () {
        return {
            form: useForm({
                school_year: null,
                school_semester: null,
                krs_sks: null,
                krs_file: null,
            }),
        }
    },
    computed: {
        preqCreateKRS () {
            return this.canCreateKRS && this.form.krs_file && !this.isInputKrsClosed
        },
    },
    methods: {
        store () {
            if (this.preqCreateKRS)
                this.form.post(this.route('mahasiswa.krs.store'))
            else this.alertCreateKRS()
        },
        alertCreateKRS () {
            if (this.isInputKrsClosed)
                Swal.fire(
                    'Gagal Input KRS',
                    'Periode penginputan sudah di tutup.',
                    'error',
                )
            else if(!this.form.krs_file) {
                Swal.fire(
                    'Gagal Input KRS',
                    'File Scan KRS wajib disertakan',
                    'error',
                )
            }
            else
                Swal.fire(
                    'Gagal Input KRS',
                    'Tidak dapat melakukan input KRS dan KHS. <br/>' +
                    'KRS dan KHS  sudah di inputkan. <br/>' +
                    'Mohon menunggu hasil verifikasi.',
                    'error',
                )
        },
    },
}
</script>
